import React from 'react';
import { useTranslation } from 'react-i18next';

import type { IdUserDto } from '@/services/ws-companies/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Filter } from '@/js/libs/ui/src/V2';

import type { Option } from 'src/types';
import { useCreatedByUsersOptions } from '../hooks/useCreatedByUsersOptions';

interface CreatedByUserFilterProps {
  value: Option<IdUserDto> | null;
  onChange: (value: Option<IdUserDto> | null) => void;
  label?: string;
}

export const CreatedByUserFilter: React.FC<CreatedByUserFilterProps> = React.memo(function CreatedByUserFilter({ value, onChange, label }) {
  const [t] = useTranslation(['backend', 'common']);
  const { options, pending: loading } = useCreatedByUsersOptions();

  const handleChange = useCallbackRef((option: Option<IdUserDto> | null) => {
    onChange(option);
  });

  return (
    <Filter
      label={label || t('common:CREATED_BY')}
      loading={loading}
      selected={value}
      onChange={handleChange}
      options={options}
      isClearable
      dataTestId='created-by-dropdown'
    />
  );
});
